import { DcBaseComponent } from '@deleteagency/dc';
import { eventBus } from 'general/js/events';
import constants from './constants';

export default class SearchEditTriggerComponent extends DcBaseComponent {
    static getNamespace() {
        return 'search-edit-trigger';
    }

    onInit() {
        this.addListener(this.element, 'click', () => eventBus.emit(constants.EVENT_SEARCH_EDIT_CLICK));
    }
}
